import React from 'react';
import { useSelector } from 'react-redux';
import { NavigationItem } from '@/components/MainSideBar/components/NavigationItem';
import { VIEWS } from '@/util/enums/views.constants';
import { TrevorIcon } from '@trevor/ui-components';
import { getSavedQueriesCount } from '@/store-selectors';
import { useMatches } from 'react-router-dom';
import { intersection } from 'ramda';

const SAVED_QUERIES_ROUTE_IDS = ['0-1-1', '0-1-1-0'];
export const SavedQueriesNavigationItem = () => {
  const activeRoutesIds = useMatches().map((r) => r.id);
  const hasSavedQueries = useSelector(getSavedQueriesCount) > 0;

  const isActive =
    intersection(activeRoutesIds, SAVED_QUERIES_ROUTE_IDS).length > 0;

  return (
    <NavigationItem
      tab={VIEWS}
      tooltipText={
        hasSavedQueries
          ? 'Saved queries'
          : 'Your saved queries will appear here'
      }
      disabled={!hasSavedQueries}
      active={isActive}
    >
      <TrevorIcon name="floppy" size="md" />
    </NavigationItem>
  );
};
